import { isLocalStudyExperience } from '@/pages/try/studyExperience/mode';
export function workingDraftStorage(): Storage {
  return isLocalStudyExperience() ? sessionStorage : localStorage;
}
